'use strict';

import _ from 'lodash';

function resizeObserve (element, callback, options = {}) {
  let isFirstTime = true;
  const observer = new ResizeObserver(_.debounce(entries => {
    if (options.skipFirst === true && isFirstTime === true) {
      isFirstTime = false;
      return;
    }
    if (entries[0].contentRect.width <= 0) return;
    callback();
  }, 250));
  observer.observe(element);
  return observer;
}

function resizeUnobserve (observer) {
  observer.disconnect();
}

export default {
  observe: resizeObserve,
  unobserve: resizeUnobserve
};
